import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../../../../config/config.service';
import { ProducaoParam } from '../../../../types/ProducaoParam.type';

@Injectable({
  providedIn: 'root'
})
export class ProducaoParamService {

  constructor(private httpClient: HttpClient, private configService: ConfigService) { }

  private urlBase(): string {
    return `${this.configService.getApiUrlRoot()}/producao-industrial-pro/producao-param`;
  }

  private urlItem(empCodemp: string, varCodigo: string, sufCodigo: string): string {
    return `${this.urlBase()}/${encodeURIComponent(empCodemp)}/${encodeURIComponent(varCodigo)}/${encodeURIComponent(sufCodigo)}`;
  }

  getList(){
    return this.httpClient.get<ProducaoParam[]>(this.urlBase());
  }

  getOne(empCodemp: string, varCodigo: string, sufCodigo: string){
    return this.httpClient.get<ProducaoParam>(this.urlItem(empCodemp, varCodigo, sufCodigo));
  }

  post(producaoParam: ProducaoParam){
    return this.httpClient.post<ProducaoParam>(this.urlBase(), producaoParam);
  }

  put(producaoParam: ProducaoParam){
    return this.httpClient.put<ProducaoParam>(this.urlItem(producaoParam.empCodemp, producaoParam.varCodigo, producaoParam.sufCodigo), producaoParam);
  }

  delete(empCodemp: string, varCodigo: string, sufCodigo: string){
    return this.httpClient.delete(this.urlItem(empCodemp, varCodigo, sufCodigo));
  }

  reativar(empCodemp: string, varCodigo: string, sufCodigo: string){
    return this.httpClient.patch<ProducaoParam>(`${this.urlItem(empCodemp, varCodigo, sufCodigo)}/reativar`, null);
  }
}
